"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const url = require("url");
const axios_1 = require("axios");
const BASE_PATH = "http://localhost".replace(/\/+$/, "");
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, axios = axios_1.default) {
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
exports.BaseAPI = BaseAPI;
;
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
exports.RequiredError = RequiredError;
var BreakFenceStatusEnum;
(function (BreakFenceStatusEnum) {
    BreakFenceStatusEnum["NEW"] = "NEW";
    BreakFenceStatusEnum["UPCOMING"] = "UPCOMING";
    BreakFenceStatusEnum["ACTIVE"] = "ACTIVE";
    BreakFenceStatusEnum["DROPPED"] = "DROPPED";
    BreakFenceStatusEnum["CANCELLED"] = "CANCELLED";
})(BreakFenceStatusEnum = exports.BreakFenceStatusEnum || (exports.BreakFenceStatusEnum = {}));
var CardTypeEnum;
(function (CardTypeEnum) {
    CardTypeEnum["CowEscaped"] = "CowEscaped";
    CardTypeEnum["PaddockArrival"] = "PaddockArrival";
    CardTypeEnum["PaddockShifting"] = "PaddockShifting";
    CardTypeEnum["DeviceNotResponding"] = "DeviceNotResponding";
})(CardTypeEnum = exports.CardTypeEnum || (exports.CardTypeEnum = {}));
var CattleBreedingEventTypeEnum;
(function (CattleBreedingEventTypeEnum) {
    CattleBreedingEventTypeEnum["VETDIAGNOSIS"] = "VET_DIAGNOSIS";
    CattleBreedingEventTypeEnum["MATING"] = "MATING";
    CattleBreedingEventTypeEnum["CALVING"] = "CALVING";
    CattleBreedingEventTypeEnum["HEAT"] = "HEAT";
})(CattleBreedingEventTypeEnum = exports.CattleBreedingEventTypeEnum || (exports.CattleBreedingEventTypeEnum = {}));
var CattleBreedingEventUpdateTypeEnum;
(function (CattleBreedingEventUpdateTypeEnum) {
    CattleBreedingEventUpdateTypeEnum["CREATED"] = "CREATED";
    CattleBreedingEventUpdateTypeEnum["UPDATED"] = "UPDATED";
    CattleBreedingEventUpdateTypeEnum["DELETED"] = "DELETED";
})(CattleBreedingEventUpdateTypeEnum = exports.CattleBreedingEventUpdateTypeEnum || (exports.CattleBreedingEventUpdateTypeEnum = {}));
var CattleMatingTypeEnum;
(function (CattleMatingTypeEnum) {
    CattleMatingTypeEnum["ARTIFICALINSEMINATION"] = "ARTIFICAL_INSEMINATION";
    CattleMatingTypeEnum["BULL"] = "BULL";
})(CattleMatingTypeEnum = exports.CattleMatingTypeEnum || (exports.CattleMatingTypeEnum = {}));
var CattleUpdateEventTypeEnum;
(function (CattleUpdateEventTypeEnum) {
    CattleUpdateEventTypeEnum["Created"] = "Created";
    CattleUpdateEventTypeEnum["Removed"] = "Removed";
    CattleUpdateEventTypeEnum["AttributeUpdate"] = "AttributeUpdate";
    CattleUpdateEventTypeEnum["DeviceUpdate"] = "DeviceUpdate";
    CattleUpdateEventTypeEnum["MobUpdate"] = "MobUpdate";
    CattleUpdateEventTypeEnum["FarmUpdate"] = "FarmUpdate";
})(CattleUpdateEventTypeEnum = exports.CattleUpdateEventTypeEnum || (exports.CattleUpdateEventTypeEnum = {}));
var CommandOriginEnum;
(function (CommandOriginEnum) {
    CommandOriginEnum["UPCOMINGBREAK"] = "UPCOMING_BREAK";
    CommandOriginEnum["BREAKSHAPEUPDATED"] = "BREAK_SHAPE_UPDATED";
    CommandOriginEnum["BREAKCANCELLED"] = "BREAK_CANCELLED";
    CommandOriginEnum["DROPFENCENOSHIFT"] = "DROP_FENCE_NO_SHIFT";
    CommandOriginEnum["DROPFENCESHIFTTONEXT"] = "DROP_FENCE_SHIFT_TO_NEXT";
    CommandOriginEnum["DROPFENCEEXITPADDOCK"] = "DROP_FENCE_EXIT_PADDOCK";
    CommandOriginEnum["FUTURECOMMANDCANCELLED"] = "FUTURE_COMMAND_CANCELLED";
    CommandOriginEnum["EXITPADDOCKSHIFT"] = "EXIT_PADDOCK_SHIFT";
    CommandOriginEnum["INCIDENT"] = "INCIDENT";
})(CommandOriginEnum = exports.CommandOriginEnum || (exports.CommandOriginEnum = {}));
var CommandTypeEnum;
(function (CommandTypeEnum) {
    CommandTypeEnum["SETZONE"] = "SET_ZONE";
    CommandTypeEnum["EXITZONE"] = "EXIT_ZONE";
    CommandTypeEnum["PAUSE"] = "PAUSE";
    CommandTypeEnum["DELETECOMMANDS"] = "DELETE_COMMANDS";
    CommandTypeEnum["CLEARSTATE"] = "CLEAR_STATE";
})(CommandTypeEnum = exports.CommandTypeEnum || (exports.CommandTypeEnum = {}));
var CommsTypeEnum;
(function (CommsTypeEnum) {
    CommsTypeEnum["UNICAST"] = "UNICAST";
    CommsTypeEnum["MULTICAST"] = "MULTICAST";
})(CommsTypeEnum = exports.CommsTypeEnum || (exports.CommsTypeEnum = {}));
var CowEscapedTimelineCardStateEnum;
(function (CowEscapedTimelineCardStateEnum) {
    CowEscapedTimelineCardStateEnum["Open"] = "Open";
    CowEscapedTimelineCardStateEnum["Acknowledged"] = "Acknowledged";
})(CowEscapedTimelineCardStateEnum = exports.CowEscapedTimelineCardStateEnum || (exports.CowEscapedTimelineCardStateEnum = {}));
var CowHealthStatusChangeEventTypeEnum;
(function (CowHealthStatusChangeEventTypeEnum) {
    CowHealthStatusChangeEventTypeEnum["FLAGGED"] = "FLAGGED";
    CowHealthStatusChangeEventTypeEnum["UNFLAGGED"] = "UNFLAGGED";
    CowHealthStatusChangeEventTypeEnum["CONFIRMEDASSICK"] = "CONFIRMED_AS_SICK";
    CowHealthStatusChangeEventTypeEnum["SICKNESSRESOLVED"] = "SICKNESS_RESOLVED";
})(CowHealthStatusChangeEventTypeEnum = exports.CowHealthStatusChangeEventTypeEnum || (exports.CowHealthStatusChangeEventTypeEnum = {}));
var DeviceNotRespondingTimelineCardStateEnum;
(function (DeviceNotRespondingTimelineCardStateEnum) {
    DeviceNotRespondingTimelineCardStateEnum["Open"] = "Open";
    DeviceNotRespondingTimelineCardStateEnum["Acknowledged"] = "Acknowledged";
})(DeviceNotRespondingTimelineCardStateEnum = exports.DeviceNotRespondingTimelineCardStateEnum || (exports.DeviceNotRespondingTimelineCardStateEnum = {}));
var DropBreakFenceIntentEnum;
(function (DropBreakFenceIntentEnum) {
    DropBreakFenceIntentEnum["DROPFENCE"] = "DROP_FENCE";
    DropBreakFenceIntentEnum["NEXTBREAK"] = "NEXT_BREAK";
    DropBreakFenceIntentEnum["SHIFTTONEWAREAINBREAK"] = "SHIFT_TO_NEW_AREA_IN_BREAK";
    DropBreakFenceIntentEnum["EXITPADDOCK"] = "EXIT_PADDOCK";
})(DropBreakFenceIntentEnum = exports.DropBreakFenceIntentEnum || (exports.DropBreakFenceIntentEnum = {}));
var FarmTimezone;
(function (FarmTimezone) {
    FarmTimezone["PacificAuckland"] = "Pacific/Auckland";
    FarmTimezone["EuropeAmsterdam"] = "Europe/Amsterdam";
    FarmTimezone["EuropeDublin"] = "Europe/Dublin";
    FarmTimezone["AustraliaHobart"] = "Australia/Hobart";
})(FarmTimezone = exports.FarmTimezone || (exports.FarmTimezone = {}));
var FindHistoryEventsFilterOperatorsEnum;
(function (FindHistoryEventsFilterOperatorsEnum) {
    FindHistoryEventsFilterOperatorsEnum["EQUALS"] = "EQUALS";
    FindHistoryEventsFilterOperatorsEnum["NOTEQUALS"] = "NOT_EQUALS";
    FindHistoryEventsFilterOperatorsEnum["LESSTHAN"] = "LESS_THAN";
    FindHistoryEventsFilterOperatorsEnum["LESSTHANOREQUALS"] = "LESS_THAN_OR_EQUALS";
    FindHistoryEventsFilterOperatorsEnum["GREATERTHAN"] = "GREATER_THAN";
    FindHistoryEventsFilterOperatorsEnum["GREATERTHANOREQUALS"] = "GREATER_THAN_OR_EQUALS";
    FindHistoryEventsFilterOperatorsEnum["IN"] = "IN";
    FindHistoryEventsFilterOperatorsEnum["BEGINSWITH"] = "BEGINS_WITH";
    FindHistoryEventsFilterOperatorsEnum["CONTAINS"] = "CONTAINS";
    FindHistoryEventsFilterOperatorsEnum["ATTRIBUTEEXISTS"] = "ATTRIBUTE_EXISTS";
})(FindHistoryEventsFilterOperatorsEnum = exports.FindHistoryEventsFilterOperatorsEnum || (exports.FindHistoryEventsFilterOperatorsEnum = {}));
var HeadingTestOverrideEnum;
(function (HeadingTestOverrideEnum) {
    HeadingTestOverrideEnum["NONE"] = "HEADING_TEST_OVERRIDE_NONE";
    HeadingTestOverrideEnum["FORCEPASS"] = "HEADING_TEST_OVERRIDE_FORCE_PASS";
    HeadingTestOverrideEnum["FORCEFAIL"] = "HEADING_TEST_OVERRIDE_FORCE_FAIL";
})(HeadingTestOverrideEnum = exports.HeadingTestOverrideEnum || (exports.HeadingTestOverrideEnum = {}));
var HistoryBreakFenceEventTypeEnum;
(function (HistoryBreakFenceEventTypeEnum) {
    HistoryBreakFenceEventTypeEnum["DROP"] = "DROP";
    HistoryBreakFenceEventTypeEnum["UPCOMING"] = "UPCOMING";
    HistoryBreakFenceEventTypeEnum["UPDATE"] = "UPDATE";
    HistoryBreakFenceEventTypeEnum["CANCEL"] = "CANCEL";
})(HistoryBreakFenceEventTypeEnum = exports.HistoryBreakFenceEventTypeEnum || (exports.HistoryBreakFenceEventTypeEnum = {}));
var HistoryDeviceCommandStatusEnum;
(function (HistoryDeviceCommandStatusEnum) {
    HistoryDeviceCommandStatusEnum["NOTSYNCED"] = "NOT_SYNCED";
    HistoryDeviceCommandStatusEnum["SYNCING"] = "SYNCING";
    HistoryDeviceCommandStatusEnum["SYNCED"] = "SYNCED";
    HistoryDeviceCommandStatusEnum["FAILEDTOSYNC"] = "FAILED_TO_SYNC";
    HistoryDeviceCommandStatusEnum["ACTIVE"] = "ACTIVE";
    HistoryDeviceCommandStatusEnum["COMPLETED"] = "COMPLETED";
})(HistoryDeviceCommandStatusEnum = exports.HistoryDeviceCommandStatusEnum || (exports.HistoryDeviceCommandStatusEnum = {}));
var HistoryEventTypeEnum;
(function (HistoryEventTypeEnum) {
    HistoryEventTypeEnum["DeviceCommandEvent"] = "DeviceCommandEvent";
    HistoryEventTypeEnum["BreakFenceEvent"] = "BreakFenceEvent";
    HistoryEventTypeEnum["ShiftEvent"] = "ShiftEvent";
    HistoryEventTypeEnum["DeviceLocationEvent"] = "DeviceLocationEvent";
    HistoryEventTypeEnum["CattleUpdateEvent"] = "CattleUpdateEvent";
    HistoryEventTypeEnum["MobUpdateEvent"] = "MobUpdateEvent";
    HistoryEventTypeEnum["CattleBreedingUpdateEvent"] = "CattleBreedingUpdateEvent";
    HistoryEventTypeEnum["DeviceUpdateEvent"] = "DeviceUpdateEvent";
    HistoryEventTypeEnum["DeviceFleetStatusUpdateEvent"] = "DeviceFleetStatusUpdateEvent";
    HistoryEventTypeEnum["DeviceRequestResponseEvent"] = "DeviceRequestResponseEvent";
    HistoryEventTypeEnum["SettingsEvent"] = "SettingsEvent";
    HistoryEventTypeEnum["FarmSettingsUpdateEvent"] = "FarmSettingsUpdateEvent";
    HistoryEventTypeEnum["CowHealthStatusEvent"] = "CowHealthStatusEvent";
    HistoryEventTypeEnum["GroupUpdateEvent"] = "GroupUpdateEvent";
})(HistoryEventTypeEnum = exports.HistoryEventTypeEnum || (exports.HistoryEventTypeEnum = {}));
var ICowtrollerGroupUpdateTypeEnum;
(function (ICowtrollerGroupUpdateTypeEnum) {
    ICowtrollerGroupUpdateTypeEnum["GROUPCREATED"] = "GROUP_CREATED";
    ICowtrollerGroupUpdateTypeEnum["DEVICEADDED"] = "DEVICE_ADDED";
    ICowtrollerGroupUpdateTypeEnum["DEVICEREMOVED"] = "DEVICE_REMOVED";
})(ICowtrollerGroupUpdateTypeEnum = exports.ICowtrollerGroupUpdateTypeEnum || (exports.ICowtrollerGroupUpdateTypeEnum = {}));
var IGeoJsonFeatureType;
(function (IGeoJsonFeatureType) {
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["Feature"] = "Feature";
    })(TypeEnum = IGeoJsonFeatureType.TypeEnum || (IGeoJsonFeatureType.TypeEnum = {}));
})(IGeoJsonFeatureType = exports.IGeoJsonFeatureType || (exports.IGeoJsonFeatureType = {}));
var IHealthCaseStatusEnum;
(function (IHealthCaseStatusEnum) {
    IHealthCaseStatusEnum["OPEN"] = "OPEN";
    IHealthCaseStatusEnum["RESOLVED"] = "RESOLVED";
})(IHealthCaseStatusEnum = exports.IHealthCaseStatusEnum || (exports.IHealthCaseStatusEnum = {}));
var IPolygonTypeDTO;
(function (IPolygonTypeDTO) {
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["Polygon"] = "Polygon";
    })(TypeEnum = IPolygonTypeDTO.TypeEnum || (IPolygonTypeDTO.TypeEnum = {}));
})(IPolygonTypeDTO = exports.IPolygonTypeDTO || (exports.IPolygonTypeDTO = {}));
var LogLevelEnum;
(function (LogLevelEnum) {
    LogLevelEnum["NONE"] = "LOG_LEVEL_NONE";
    LogLevelEnum["ERROR"] = "LOG_LEVEL_ERROR";
    LogLevelEnum["WARN"] = "LOG_LEVEL_WARN";
    LogLevelEnum["INFO"] = "LOG_LEVEL_INFO";
    LogLevelEnum["DEBUG"] = "LOG_LEVEL_DEBUG";
    LogLevelEnum["VERBOSE"] = "LOG_LEVEL_VERBOSE";
})(LogLevelEnum = exports.LogLevelEnum || (exports.LogLevelEnum = {}));
var MobUpdateEventTypeEnum;
(function (MobUpdateEventTypeEnum) {
    MobUpdateEventTypeEnum["Created"] = "Created";
    MobUpdateEventTypeEnum["Removed"] = "Removed";
    MobUpdateEventTypeEnum["AttributeUpdate"] = "AttributeUpdate";
})(MobUpdateEventTypeEnum = exports.MobUpdateEventTypeEnum || (exports.MobUpdateEventTypeEnum = {}));
var PaddockArrivalTimelineCardStateEnum;
(function (PaddockArrivalTimelineCardStateEnum) {
    PaddockArrivalTimelineCardStateEnum["InProgress"] = "InProgress";
    PaddockArrivalTimelineCardStateEnum["Done"] = "Done";
})(PaddockArrivalTimelineCardStateEnum = exports.PaddockArrivalTimelineCardStateEnum || (exports.PaddockArrivalTimelineCardStateEnum = {}));
var PaddockShiftingTimelineCardStateEnum;
(function (PaddockShiftingTimelineCardStateEnum) {
    PaddockShiftingTimelineCardStateEnum["InProgress"] = "InProgress";
    PaddockShiftingTimelineCardStateEnum["Done"] = "Done";
})(PaddockShiftingTimelineCardStateEnum = exports.PaddockShiftingTimelineCardStateEnum || (exports.PaddockShiftingTimelineCardStateEnum = {}));
var RequestMessagePriorityEnum;
(function (RequestMessagePriorityEnum) {
    RequestMessagePriorityEnum["HIGHEST"] = "HIGHEST";
    RequestMessagePriorityEnum["HIGH"] = "HIGH";
    RequestMessagePriorityEnum["MEDIUMHIGH"] = "MEDIUM_HIGH";
    RequestMessagePriorityEnum["NORMAL"] = "NORMAL";
    RequestMessagePriorityEnum["MEDIUMLOW"] = "MEDIUM_LOW";
    RequestMessagePriorityEnum["LOW"] = "LOW";
    RequestMessagePriorityEnum["LOWEST"] = "LOWEST";
})(RequestMessagePriorityEnum = exports.RequestMessagePriorityEnum || (exports.RequestMessagePriorityEnum = {}));
var SeverityLevelEnum;
(function (SeverityLevelEnum) {
    SeverityLevelEnum["LOW"] = "LOW";
    SeverityLevelEnum["MEDIUM"] = "MEDIUM";
    SeverityLevelEnum["HIGH"] = "HIGH";
    SeverityLevelEnum["UNKNOWN"] = "UNKNOWN";
    SeverityLevelEnum["NOTAPPLICABLE"] = "NOT_APPLICABLE";
    SeverityLevelEnum["CRITICAL"] = "CRITICAL";
})(SeverityLevelEnum = exports.SeverityLevelEnum || (exports.SeverityLevelEnum = {}));
var ShiftStatusEnum;
(function (ShiftStatusEnum) {
    ShiftStatusEnum["SCHEDULED"] = "SCHEDULED";
    ShiftStatusEnum["CANCELLED"] = "CANCELLED";
    ShiftStatusEnum["STARTING"] = "STARTING";
    ShiftStatusEnum["ACTIVE"] = "ACTIVE";
    ShiftStatusEnum["COMPLETED"] = "COMPLETED";
})(ShiftStatusEnum = exports.ShiftStatusEnum || (exports.ShiftStatusEnum = {}));
var ShiftTargetEnum;
(function (ShiftTargetEnum) {
    ShiftTargetEnum["FULLHERD"] = "FULL_HERD";
    ShiftTargetEnum["SELECTCOWS"] = "SELECT_COWS";
})(ShiftTargetEnum = exports.ShiftTargetEnum || (exports.ShiftTargetEnum = {}));
var ShiftTypeEnum;
(function (ShiftTypeEnum) {
    ShiftTypeEnum["EXITPADDOCK"] = "EXIT_PADDOCK";
    ShiftTypeEnum["BREAKTOBREAK"] = "BREAK_TO_BREAK";
    ShiftTypeEnum["NOSHIFT"] = "NO_SHIFT";
})(ShiftTypeEnum = exports.ShiftTypeEnum || (exports.ShiftTypeEnum = {}));
var SicknessTypeEnum;
(function (SicknessTypeEnum) {
    SicknessTypeEnum["MASTITIS"] = "MASTITIS";
    SicknessTypeEnum["MYCOPLASMABOVIS"] = "MYCOPLASMA_BOVIS";
    SicknessTypeEnum["LAMENESS"] = "LAMENESS";
    SicknessTypeEnum["ACIDOSIS"] = "ACIDOSIS";
    SicknessTypeEnum["BLOAT"] = "BLOAT";
    SicknessTypeEnum["BVDVIRUS"] = "BVD_VIRUS";
    SicknessTypeEnum["CALVING"] = "CALVING";
    SicknessTypeEnum["CALVINGCOMPLICATION"] = "CALVING_COMPLICATION";
    SicknessTypeEnum["COCCIDIOSIS"] = "COCCIDIOSIS";
    SicknessTypeEnum["COPPERDEFICIENCY"] = "COPPER_DEFICIENCY";
    SicknessTypeEnum["DOWNCOW"] = "DOWN_COW";
    SicknessTypeEnum["ENDOMETRITIS"] = "ENDOMETRITIS";
    SicknessTypeEnum["FACIALECZEMA"] = "FACIAL_ECZEMA";
    SicknessTypeEnum["GRASSSTAGGERS"] = "GRASS_STAGGERS";
    SicknessTypeEnum["HEATSTRESS"] = "HEAT_STRESS";
    SicknessTypeEnum["JOHNESDISEASE"] = "JOHNE_S_DISEASE";
    SicknessTypeEnum["KETOSIS"] = "KETOSIS";
    SicknessTypeEnum["LEPTOSPIROSIS"] = "LEPTOSPIROSIS";
    SicknessTypeEnum["LEFTDISPLACEDABOMASUM"] = "LEFT_DISPLACED_ABOMASUM";
    SicknessTypeEnum["MILKFEVER"] = "MILK_FEVER";
    SicknessTypeEnum["NITRATEPOISONING"] = "NITRATE_POISONING";
    SicknessTypeEnum["PERITONITIS"] = "PERITONITIS";
    SicknessTypeEnum["RIGHTDISPLACEDABOMASUM"] = "RIGHT_DISPLACED_ABOMASUM";
    SicknessTypeEnum["RETAINEDFOETALMEMBRANE"] = "RETAINED_FOETAL_MEMBRANE";
    SicknessTypeEnum["RYEGRASSSTAGGERS"] = "RYEGRASS_STAGGERS";
    SicknessTypeEnum["SALMONELLA"] = "SALMONELLA";
    SicknessTypeEnum["SCOURS"] = "SCOURS";
    SicknessTypeEnum["SODIUMDEFICIENCY"] = "SODIUM_DEFICIENCY";
    SicknessTypeEnum["THEILERIA"] = "THEILERIA";
    SicknessTypeEnum["TRACEELEMENTS"] = "TRACE_ELEMENTS";
    SicknessTypeEnum["OTHER"] = "OTHER";
})(SicknessTypeEnum = exports.SicknessTypeEnum || (exports.SicknessTypeEnum = {}));
var SymptomTypeEnum;
(function (SymptomTypeEnum) {
    SymptomTypeEnum["DECREASEDMOVEMENTANDGRAZING"] = "DECREASED_MOVEMENT_AND_GRAZING";
    SymptomTypeEnum["PROLONGEDDECREASEDMOVEMENTANDGRAZING"] = "PROLONGED_DECREASED_MOVEMENT_AND_GRAZING";
    SymptomTypeEnum["PROLONGEDDECREASEDGRAZING"] = "PROLONGED_DECREASED_GRAZING";
    SymptomTypeEnum["DECREASEDRUMINATION"] = "DECREASED_RUMINATION";
    SymptomTypeEnum["PROLONGEDDECREASEDRUMINATION"] = "PROLONGED_DECREASED_RUMINATION";
    SymptomTypeEnum["IMMOBILE"] = "IMMOBILE";
    SymptomTypeEnum["ABNORMALLYLONGNOTRUMINATINGBOUT"] = "ABNORMALLY_LONG_NOT_RUMINATING_BOUT";
    SymptomTypeEnum["ABNORMALLYLONGRESTINGBOUT"] = "ABNORMALLY_LONG_RESTING_BOUT";
})(SymptomTypeEnum = exports.SymptomTypeEnum || (exports.SymptomTypeEnum = {}));
exports.TimelineCardApiAxiosParamCreator = function (configuration) {
    return {
        findCardById(id, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling findCardById.');
            }
            const localVarPath = `/timeline/cards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        findCards(pageSize, pageNumber, mobId, isActive, options = {}) {
            const localVarPath = `/timeline/cards`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            if (mobId !== undefined) {
                localVarQueryParameter['mobId'] = mobId;
            }
            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        timeoutCheck(options = {}) {
            const localVarPath = `/timeline/cards/timeout-check`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateCardState(id, iUpdateTimelineCardStateDTO, options = {}) {
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateCardState.');
            }
            if (iUpdateTimelineCardStateDTO === null || iUpdateTimelineCardStateDTO === undefined) {
                throw new RequiredError('iUpdateTimelineCardStateDTO', 'Required parameter iUpdateTimelineCardStateDTO was null or undefined when calling updateCardState.');
            }
            const localVarPath = `/timeline/cards/{id}/state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, baseOptions, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("IUpdateTimelineCardStateDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iUpdateTimelineCardStateDTO || {}) : (iUpdateTimelineCardStateDTO || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TimelineCardApiFp = function (configuration) {
    return {
        findCardById(id, options) {
            const localVarAxiosArgs = exports.TimelineCardApiAxiosParamCreator(configuration).findCardById(id, options);
            return (axios = axios_1.default, basePath = BASE_PATH) => {
                const axiosRequestArgs = Object.assign(localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        findCards(pageSize, pageNumber, mobId, isActive, options) {
            const localVarAxiosArgs = exports.TimelineCardApiAxiosParamCreator(configuration).findCards(pageSize, pageNumber, mobId, isActive, options);
            return (axios = axios_1.default, basePath = BASE_PATH) => {
                const axiosRequestArgs = Object.assign(localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        timeoutCheck(options) {
            const localVarAxiosArgs = exports.TimelineCardApiAxiosParamCreator(configuration).timeoutCheck(options);
            return (axios = axios_1.default, basePath = BASE_PATH) => {
                const axiosRequestArgs = Object.assign(localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        updateCardState(id, iUpdateTimelineCardStateDTO, options) {
            const localVarAxiosArgs = exports.TimelineCardApiAxiosParamCreator(configuration).updateCardState(id, iUpdateTimelineCardStateDTO, options);
            return (axios = axios_1.default, basePath = BASE_PATH) => {
                const axiosRequestArgs = Object.assign(localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
exports.TimelineCardApiFactory = function (configuration, basePath, axios) {
    return {
        findCardById(id, options) {
            return exports.TimelineCardApiFp(configuration).findCardById(id, options)(axios, basePath);
        },
        findCards(pageSize, pageNumber, mobId, isActive, options) {
            return exports.TimelineCardApiFp(configuration).findCards(pageSize, pageNumber, mobId, isActive, options)(axios, basePath);
        },
        timeoutCheck(options) {
            return exports.TimelineCardApiFp(configuration).timeoutCheck(options)(axios, basePath);
        },
        updateCardState(id, iUpdateTimelineCardStateDTO, options) {
            return exports.TimelineCardApiFp(configuration).updateCardState(id, iUpdateTimelineCardStateDTO, options)(axios, basePath);
        },
    };
};
class TimelineCardApi extends BaseAPI {
    findCardById(id, options) {
        return exports.TimelineCardApiFp(this.configuration).findCardById(id, options)(this.axios, this.basePath);
    }
    findCards(pageSize, pageNumber, mobId, isActive, options) {
        return exports.TimelineCardApiFp(this.configuration).findCards(pageSize, pageNumber, mobId, isActive, options)(this.axios, this.basePath);
    }
    timeoutCheck(options) {
        return exports.TimelineCardApiFp(this.configuration).timeoutCheck(options)(this.axios, this.basePath);
    }
    updateCardState(id, iUpdateTimelineCardStateDTO, options) {
        return exports.TimelineCardApiFp(this.configuration).updateCardState(id, iUpdateTimelineCardStateDTO, options)(this.axios, this.basePath);
    }
}
exports.TimelineCardApi = TimelineCardApi;
exports.TimelineCleanUpApiAxiosParamCreator = function (configuration) {
    return {
        cleanUp(farmId, options = {}) {
            if (farmId === null || farmId === undefined) {
                throw new RequiredError('farmId', 'Required parameter farmId was null or undefined when calling cleanUp.');
            }
            const localVarPath = `/timeline/clean-up/{farmId}`
                .replace(`{${"farmId"}}`, encodeURIComponent(String(farmId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, baseOptions, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TimelineCleanUpApiFp = function (configuration) {
    return {
        cleanUp(farmId, options) {
            const localVarAxiosArgs = exports.TimelineCleanUpApiAxiosParamCreator(configuration).cleanUp(farmId, options);
            return (axios = axios_1.default, basePath = BASE_PATH) => {
                const axiosRequestArgs = Object.assign(localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
exports.TimelineCleanUpApiFactory = function (configuration, basePath, axios) {
    return {
        cleanUp(farmId, options) {
            return exports.TimelineCleanUpApiFp(configuration).cleanUp(farmId, options)(axios, basePath);
        },
    };
};
class TimelineCleanUpApi extends BaseAPI {
    cleanUp(farmId, options) {
        return exports.TimelineCleanUpApiFp(this.configuration).cleanUp(farmId, options)(this.axios, this.basePath);
    }
}
exports.TimelineCleanUpApi = TimelineCleanUpApi;
exports.TimelineHistoryListApiAxiosParamCreator = function (configuration) {
    return {
        findHistory(from, to, filters, paginationToken, options = {}) {
            if (from === null || from === undefined) {
                throw new RequiredError('from', 'Required parameter from was null or undefined when calling findHistory.');
            }
            if (to === null || to === undefined) {
                throw new RequiredError('to', 'Required parameter to was null or undefined when calling findHistory.');
            }
            const localVarPath = `/timeline/history`;
            const localVarUrlObj = url.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = from.toISOString();
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to.toISOString();
            }
            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }
            if (paginationToken !== undefined) {
                localVarQueryParameter['paginationToken'] = paginationToken;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TimelineHistoryListApiFp = function (configuration) {
    return {
        findHistory(from, to, filters, paginationToken, options) {
            const localVarAxiosArgs = exports.TimelineHistoryListApiAxiosParamCreator(configuration).findHistory(from, to, filters, paginationToken, options);
            return (axios = axios_1.default, basePath = BASE_PATH) => {
                const axiosRequestArgs = Object.assign(localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
exports.TimelineHistoryListApiFactory = function (configuration, basePath, axios) {
    return {
        findHistory(from, to, filters, paginationToken, options) {
            return exports.TimelineHistoryListApiFp(configuration).findHistory(from, to, filters, paginationToken, options)(axios, basePath);
        },
    };
};
class TimelineHistoryListApi extends BaseAPI {
    findHistory(from, to, filters, paginationToken, options) {
        return exports.TimelineHistoryListApiFp(this.configuration).findHistory(from, to, filters, paginationToken, options)(this.axios, this.basePath);
    }
}
exports.TimelineHistoryListApi = TimelineHistoryListApi;
//# sourceMappingURL=api.js.map